<template>
  <div class="mb-5">
    <v-toolbar dense class="primary" dark flat>
      Please list the names of all Co-signers
    </v-toolbar>
    <v-card outlined text class="mb-0 mt-4">
      <v-card-text class="pb-0">
        Please note: Each Co-Signers must complete a separate application.
      </v-card-text>
      <div class="d-flex pa-3  justify-center">
        <v-btn @click="open()" outlined color="primary">
          Add Co-Signers
        </v-btn>
      </div>
    </v-card>

    <v-list class="mt-4" v-if="coSigner.length">
      <v-card outlined v-for="(item, key) in coSigner" :key="key" class="mb-2">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              {{ item }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="remvoe(key)">
              <v-icon color="red">
                mdi-delete
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-card>
    </v-list>
    <v-dialog v-model="dialog" max-width="400px" persistent scrollable>
      <v-card>
        <v-card-title>
          Create Co-Signer
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form class="mt-5" ref="form" v-model="valid">
            <v-text-field
              v-model="name"
              :rules="rules"
              outlined
              label="Name"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn class="mr-5" @click="dialog = false" color="error" text
            >Cancel</v-btn
          >
          <v-btn class="mr-5" @click="submit()" color="success" text
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      name: "",
      ans: "",
      dialog: false,
      valid: false,
      coSigner: [],
      min: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      rules: [v => !!v || "Field is required"],
      emailRules: [
        v => !!v || "Field is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  watch: {
    coSigner(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    open() {
      const vm = this;
      vm.form = {};
      vm.dialog = true;
    },
    remvoe(key) {
      let check = confirm("Are you sure?");
      if (!check) return;
      this.coSigner.splice(key, 1);
    },

    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.valid) return;
      vm.coSigner.push(vm.name);
      vm.name = "";
      vm.$refs.form.reset();
      vm.dialog = false;
      vm.valid = false;
    }
  }
};
</script>

<style></style>
